<template lang="pug">
section.section(
    :class="classes"
    @click="editSection"
)
    include ../base.pug
    .content-wrappers(v-if="!isEmpty || $slots.default")
        slot
        form-builder(:section="section" :edit="false" :options="options")
    el-drawer.full-height-drawer.visible-overflow(
        v-if="editable"
        :title="$t('Edit {section}', { section: section.name })"
        :visible.sync="scopedUI.form"
        :close-on-press-escape="true"
        :wrapper-closable="false"
        :append-to-body="true"
        size="1100px"
        :modal="true"
        @closed="resetDrawer"
    )
        .drawer-body(v-loading="drawer.loading")
            el-tabs(
                v-if="!drawer.loading && drawer.section"
                v-model="drawer.tab"
                tab-position="top"
            )
                el-tab-pane(name="content" :label="$t('Form')")
                    .tab-content
                        form-builder(:section="drawer.section" :edit="true" :options="options")
                el-tab-pane(name="settings" :label="$t('Settings')")
                    .block-settings
                        .settings-wrap
                            include ../settings.pug
        .drawer-footer
            include ../section-drawer-footer.pug
</template>

<i18n>
{
    "en": {
        "Edit {section}": "Edit {section}",
        "Form": "Form",
        "Settings": "Settings",
        "Owner email (default)": "Owner email (default)",
        "Defined in the email template": "Defined in the email template"
    },
    "de": {
        "Edit {section}": "{section} bearbeiten",
        "Form": "Formular",
        "Settings": "Einstellungen",
        "Owner email (default)": "Inhaber-E-Mail (Standard)",
        "Defined in the email template": "In der E-Mail-Vorlage definiert"
    }
}
</i18n>

<script>
import _ from 'lodash'

import Section from '@/components/Page/Sections/Section'
import FormBuilder from '../Partials/FormBuilder/FormBuilder'

export default {
    name: 'FormV2',
    extends: Section,
    components: {
        FormBuilder,
    },
    computed: {
        editable() {
            return true
        },
        // Notification settings come straight from the section YAML; enrich a couple
        // of placeholders that hint at the fallback behaviour (mirrors Form section).
        settings() {
            let settings = _.cloneDeep(
                _.get(this.sectionConfig, 'settings') || _.get(this.defaultConfig, 'settings') || []
            )

            // make divider keys unique (mirrors the base Section behaviour)
            settings.forEach((setting, index) => {
                if (setting.type === 'divider') setting.key = `${setting.key}-${index}`
            })

            const ownerEmail = _.get(this.activeCms, 'owner.user.email')
            settings.forEach(setting => {
                if (setting.key === 'to' && !setting.placeholder) {
                    setting.placeholder = ownerEmail || this.$t('Owner email (default)')
                }
                if (setting.key === 'subject' && !setting.placeholder) {
                    setting.placeholder = this.$t('Defined in the email template')
                }
            })

            return settings
        },
    },
    methods: {
        // Seed the notification toggles explicitly for a fresh form so it works out
        // of the box AND the two toggles are independently controllable (the backend
        // only treats them as independent when the values are stored). Fields are
        // seeded by the FormBuilder itself when the drawer opens on an empty form.
        ensureDefaultSettings() {
            const section = _.get(this.drawer, 'section') || this.section
            if (!section) return
            if (!section.settings) this.$set(section, 'settings', [])
            const ensure = (key, value) => {
                if (!section.settings.some(setting => setting.key === key)) {
                    section.settings.push({ key, value })
                }
            }
            ensure('send-copy-to', true)
            ensure('send-email', true)
        },
    },
    mounted() {
        this.ensureDefaultSettings()
    },
}
</script>
